import React from "react";

const RubbingAndWaxCoating = () => {
  return (
    <div>
      <div>
        <p className="mt-2 mb-2 font-bold">
          Exterior Rubbing & Wax Coating – Shine & Protection Package
        </p>
        <ul className="list-disc text-black-500">
          <li>Water Proof Effect from Wax Coating</li>
          <li>Protective Wax Coating for Long-Lasting Shine</li>
          <li>UV Protection for Paint Surface</li>
          <li>Exterior Rubbing Compound Treatment</li>
          <li>Removes Minor Scratches & Swirl Marks</li>
          <li>Restores Original Paint Gloss</li>
          <li>Premium Machine Polish Application</li>
          <li>Exterior Foam Wash After Rubbing</li>
          <li>Tyre & Bumper Polish</li>
          <li>
            <b>
              Cleaning inside bonnet is at owner's risk – Not recommended (₹100
              extra)
            </b>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default RubbingAndWaxCoating;
